import { createSelector } from 'reselect';

const getState = state => state.mentor;

// Selector to get the own mentor data
const getMentor = createSelector([getState], state => state.get('data'));

const updatePending = createSelector([getState], state => state.get('updatePending'));

const isFetching = createSelector([getState], state => state.get('isFetching'));

const getMentorSelected = createSelector([getState], state =>
  state.get('mentorSelected').get('data').toJS()
);

const getMentorSelectedLoading = createSelector([getState], state =>
  state.get('mentorSelected').get('loading')
);

export default {
  getMentor,
  updatePending,
  isFetching,
  getMentorSelected,
  getMentorSelectedLoading,
};
